import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { legacyPluginsModule } from './modules/legacyPlugins';
import { navModule } from './modules/nav';
import { signInModule } from './modules/signIn';
import { themeModule } from './modules/theme';

const app: ReturnType<typeof createApp> = createApp({
  features: [
    catalogPlugin,
    navModule,
    signInModule,
    themeModule,
    legacyPluginsModule,
  ],
});

export default app;
